import React from 'react';

const FlexColumns = ({ className = '', children }) => (
  <div className={`layout-flex-columns ${className}`}>{children}</div>
);

export default FlexColumns;
